export const MiniQ2MultipleValuesModel = {
    confsens: 0,
    dist_p0: 15,
    pulsos_p0: 2,
    intpuls_p0: 10,
    pot_tx_p0: 0,
    pot_rx_p0: 100,
    dist_p1: 30,
    pulsos_p1: 2,
    intpuls_p1: 10,
    pot_tx_p1: 0,
    pot_rx_p1: 100,
    dist_p2: 300,
    pulsos_p2: 2,
    intpuls_p2: 10,
    pot_tx_p2: 0,
    pot_rx_p2: 100,
    dist_p3: 450,
    pulsos_p3: 2,
    intpuls_p3: 10,
    pot_tx_p3: 0,
    pot_rx_p3: 100,
}

export const MiniQ2MultipleHasModel = {
    dist_p0: false,
    dist_p1: false,
    dist_p2: false,
    dist_p3: false,
}
export const MiniQ2IndividualValuesModelV1 = {
    confsens: 0,
    p0_sat_A: 7,
    p0_pul_A: 75,
    p0_hyst_A: 45,
    threshold_A: 75,
    p0_sat_B: 7,
    p0_pul_B: 75,
    p0_hyst_B: 45,
    threshold_B: 75
}
export const MiniQ2IndividualHasModelV1 = {
    p0_hyst_A: false,
    p0_hyst_B: false,
}
export const MiniQ2IndividualValuesModelV2 = {
    confsens: 0,
    p0_dist_A: 0,
    p0_sat_A: 7,
    p0_pul_A: 75,
    p0_hyst_A: 45,
    p0_threshold_A: 75,
    p0_dist_B: 0,
    p0_sat_B: 7,
    p0_pul_B: 75,
    p0_hyst_B: 45,
    p0_threshold_B: 75,
    p1_dist_A: 0,
    p1_sat_A: 7,
    p1_pul_A: 75,
    p1_hyst_A: 45,
    p1_threshold_A: 75,
    p1_dist_B: 0,
    p1_sat_B: 7,
    p1_pul_B: 75,
    p1_hyst_B: 45,
    p1_threshold_B: 75,
    p2_dist_A: 0,
    p2_sat_A: 7,
    p2_pul_A: 75,
    p2_hyst_A: 45,
    p2_threshold_A: 75,
    p2_dist_B: 0,
    p2_sat_B: 7,
    p2_pul_B: 75,
    p2_hyst_B: 45,
    p2_threshold_B: 75,

}

export const MiniQ2IndividualHasModelV2 = {
    p0_dist_A: false,
    p0_dist_B: false,
    p1_dist_A: false,
    p1_dist_B: false,
    p2_dist_A: false,
    p2_dist_B: false,
}
export const MiniQ2IndividualValuesModel = {
    confsens: 0,
    confdist: 0,
    saturation: 7,
    hysteresis: 45,
    p0_threshold_s: 10,
    p1_threshold_s: 10,
    p2_threshold_s: 10,
    p3_threshold_s: 10,
    p4_threshold_s: 10,
    p5_threshold_s: 10,
    p6_threshold_s: 10,
    p7_threshold_s: 10,
    p8_threshold_s: 10,
    p9_threshold_s: 10,
    p10_threshold_s: 10,
    p11_threshold_s: 10,
    p0_threshold_l: 10,
    p1_threshold_l: 10,
    p2_threshold_l: 10,
    p3_threshold_l: 10,
    p4_threshold_l: 10,
    p5_threshold_l: 10,
    p6_threshold_l: 10,
    p7_threshold_l: 10,
    p8_threshold_l: 10,
    p9_threshold_l: 10,
    p10_threshold_l: 10,
    p11_threshold_l: 10,
}

export const MiniQ2IndividualHasModel = {
    hysteresis: false,
}
